import { useEffect } from "react"

import { useSelector } from "react-redux"

import TitleSection from "../../Components/TitleSection/TitleSection"
import Users from "../PersonalSettings/Users"

import "./styles.less"

const TeamPage = () => {
  const { isMobile } = useSelector((state) => state.nav)

  useEffect(() => {
    document.title = "Team - Chargeback"
  }, [])

  return (
    <div className="team-page">
      <TitleSection
        icon="team"
        title="Team"
        description="Manage list of users which business account they can access."
        style={{ margin: isMobile ? "-16px -16px 16px" : "-32px -32px 24px" }}
      />

      <Users isTeamPage />
    </div>
  )
}

export default TeamPage
